import * as Yup from 'yup';
import { EUROPE } from 'enums/regions';

export default (intl, country) => {
  const isEuropeCountry = EUROPE.includes(country);

  if (isEuropeCountry) {
    return Yup.object().shape({
      project: Yup.object().shape({
        name: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un nombre' }),
        ),
        postalCode: Yup.string().required(
          intl.formatMessage({ id: 'Debe ingresar un código postal' }),
        ),
        type: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
          .typeError(intl.formatMessage({ id: 'Debe seleccionar un tipo' })),
        state: Yup.string()
          .required(
            intl.formatMessage({ id: 'Debe seleccionar una provincia' }),
          )
          .typeError(
            intl.formatMessage({ id: 'Debe seleccionar una provincia' }),
          ),
        needCase: Yup.string()
          .required(intl.formatMessage({ id: 'Debe seleccionar una opción' }))
          .typeError(intl.formatMessage({ id: 'Debe seleccionar una opción' })),
      }),
    });
  }

  return Yup.object().shape({
    project: Yup.object().shape({
      name: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un nombre' }),
      ),
      postalCode: Yup.string().required(
        intl.formatMessage({ id: 'Debe ingresar un código postal' }),
      ),
      type: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar un tipo' }))
        .typeError(intl.formatMessage({ id: 'Debe seleccionar un tipo' })),
      state: Yup.string()
        .required(intl.formatMessage({ id: 'Debe seleccionar una provincia' }))
        .typeError(
          intl.formatMessage({ id: 'Debe seleccionar una provincia' }),
        ),
    }),
  });
};
